import React, { useEffect, useState } from 'react';
import './App.css';
import Sidebar from './components/Sidebar';
import MobileNavigation from './components/MobileNavigation';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Clients from './components/Clients';
import Testimonial from './components/Testimonial';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfUse from './components/TermsOfUse';
import { navItems } from './data/siteData';

function App() {
  const [activeSection, setActiveSection] = useState('home');
  const currentPath = window.location.pathname;

  const navigateTo = (target) => {
    document.getElementById(target)?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    if (currentPath !== '/') return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.find((entry) => entry.isIntersecting);
        if (visible) setActiveSection(visible.target.id);
      },
      { rootMargin: '-25% 0px -60%', threshold: 0.05 }
    );

    navItems.forEach(({ target }) => {
      const section = document.getElementById(target);
      if (section) observer.observe(section);
    });

    return () => observer.disconnect();
  }, [currentPath]);

  if (currentPath === '/privacy-policy') return <PrivacyPolicy />;
  if (currentPath === '/terms-of-use') return <TermsOfUse />;

  return (
    <div className="app-shell">
      <Sidebar activeSection={activeSection} onNavigate={navigateTo} />
      <MobileNavigation activeSection={activeSection} onNavigate={navigateTo} />
      <main>
        <Hero onNavigate={navigateTo} />
        <About />
        <Services />
        <Clients />
        <Testimonial onNavigate={navigateTo} />
        <Contact />
      </main>
    </div>
  );
}

export default App;